'use client';

import { createContext, useContext, useMemo } from 'react';

import { createTranslator } from '@/features/i18n/lib/translator';
import type { Dictionary, Translator } from '@/features/i18n/types';

const I18nContext = createContext<{ t: Translator; locale: string } | null>(null);

export function I18nProvider({
  children,
  locale,
  dictionary,
}: {
  locale: string;
  children: React.ReactNode;
  dictionary: Dictionary;
}) {
  const value = useMemo(() => {
    const t = createTranslator(dictionary);
    return { t, locale };
  }, [dictionary, locale]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error('useI18n must be used within I18nProvider');
  return ctx;
}
